import "../App.css";
import Navbar from "../components/Navbar";

export const About = () => {
  return (
      <div className="App">
        <Navbar />
      </div>
  );
}

export default About;